module.exports = __webpack_public_path__ + "img/0104.880c648d.png";